import React, { useEffect, useState } from 'react';
import HeroSection from './HeroSection/HeroSection';
import BlogGrid from './BlogGrid/BlogGrid';
import { useRouter } from 'next/router';
import ProductCarousel from '../../global/ProductCarousel/ProductCarousel';
import { getObjFrmArray } from '../../../../commons/utils/utils';

export default function BlogHome({
  categories = [],
  tags = [],
  posts = [],
  totalCount = 0,
}) {
  const { query } = useRouter();
  const selectedCategory = query.category;
  const selectedTag = query.tag;
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeTag, setActiveTag] = useState(null);

  useEffect(() => {
    if (typeof selectedCategory != 'undefined') {
      setActiveCategory(getObjFrmArray(categories, 'slug', selectedCategory));
    }
    if (typeof selectedTag != 'undefined') {
      setActiveTag(getObjFrmArray(tags, 'slug', selectedTag));
    }
  }, [selectedCategory, selectedTag]);

  return (
    <>
      <HeroSection
        allCategories={categories}
        allTags={tags}
        currentCategory={activeCategory}
        currentTag={activeTag}
      />
      <BlogGrid
        allCategories={categories}
        allTags={tags}
        currentCategory={activeCategory}
        currentTag={activeTag}
        posts={posts}
        totalCount={totalCount}
      />
      <ProductCarousel />
    </>
  );
}
